import { render, staticRenderFns } from "./KlineChart.vue?vue&type=template&id=5277837a&scoped=true"
import script from "./KlineChart.vue?vue&type=script&lang=js"
export * from "./KlineChart.vue?vue&type=script&lang=js"
import style0 from "./KlineChart.vue?vue&type=style&index=0&id=5277837a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5277837a",
  null
  
)

export default component.exports